import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Header, Button, Icon, Divider, Card, Loader } from 'semantic-ui-react'

import DeliveryFeeOfferCard from './deliveryFeeOfferCard'
import DeliveryFeeOfferForm from './deliveryFeeOfferForm'
import RestaurantActions from '../../reducers/restaurantReducer'
import DeliveryFeeOfferActions from '../../reducers/deliveryFeeOfferReducer'

const styles = {
  Container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'auto',
  },
  HeaderWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  },
  Header: {
    display: 'flex',
    alignItems: 'center',
  },
  AddNewButton: {
    display: 'flex',
    float: 'right',
  },
}

class DeliveryFeeOffer extends React.PureComponent {
  state = {
    formVisible: false,
    deliveryFeeOffer: null,
    action: '',
  }

  componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, getDeliveryFeeOffers } = this.props

    if (!restaurantLoaded) fetchRestaurants()

    getDeliveryFeeOffers()
  }

  onEdit = deliveryFeeOffer => {
    this.setState({ formVisible: true, action: 'edit', deliveryFeeOffer })
  }

  onDelete = deliveryFeeOffer => {
    const { deleteDeliveryFeeOffer } = this.props
    const confirm = window.confirm(`Are you sure you want to delete?`)

    if (confirm) {
      deleteDeliveryFeeOffer(deliveryFeeOffer)
    }
  }

  renderDeliveryFeeOffers = deliveryFeeOffers => {
    const { restaurants } = this.props

    if (_.size(deliveryFeeOffers) === 0) return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>

    return (
      <Card.Group style={{ margin: 0 }}>
        {_.map(deliveryFeeOffers, (deliveryFeeOffer, key) => {
          return (
            <DeliveryFeeOfferCard
              key={key}
              deliveryFeeOffer={deliveryFeeOffer}
              restaurants={restaurants}
              onEdit={() => this.onEdit(deliveryFeeOffer)}
              onDelete={() => this.onDelete(deliveryFeeOffer)}
            />
          )
        })}
      </Card.Group>
    )
  }

  render() {
    const { formVisible, action, deliveryFeeOffer } = this.state
    const { restaurants, restaurantLoaded, deliveryFeeOffers, authData, saveDeliveryFeeOffer, deliveryFeeOfferLoading } = this.props

    if (!restaurantLoaded || deliveryFeeOfferLoading) {
      return (
        <React.Fragment>
          <Loader active />
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <div style={styles.Container}>
          <div style={styles.HeaderWrapper}>
            <div style={styles.Header}>
              <Header style={{ marginBottom: 0 }}>{`Delivery Fee Offers (${_.size(deliveryFeeOffers)})`}</Header>
            </div>
            <div style={styles.AddNewButton}>
              <Button icon color="black" onClick={() => this.setState({ formVisible: true, action: 'new' })}>
                <Icon name="add" /> Add New
              </Button>
            </div>
          </div>

          <div>
            <Divider style={{ margin: 14 }} />
          </div>

          <div style={{ overflow: 'auto' }}>{this.renderDeliveryFeeOffers(deliveryFeeOffers)}</div>

          {formVisible && (
            <DeliveryFeeOfferForm
              authData={authData}
              restaurants={restaurants}
              action={action}
              deliveryFeeOffers={deliveryFeeOffers}
              deliveryFeeOffer={deliveryFeeOffer}
              saveDeliveryFeeOffer={saveDeliveryFeeOffer}
              onClose={() => this.setState({ formVisible: false, action: '', deliveryFeeOffer: null })}
            />
          )}
        </div>
      </React.Fragment>
    )
  }
}

const mapState = ({ auth, restaurants, deliveryFeeOffers }) => ({
  authData: auth.data,
  restaurants: restaurants.data,
  restaurantLoaded: restaurants.loaded,
  deliveryFeeOffers: deliveryFeeOffers.data,
  deliveryFeeOfferLoading: deliveryFeeOffers.loading,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getDeliveryFeeOffers: DeliveryFeeOfferActions.getDeliveryFeeOffers,
  deleteDeliveryFeeOffer: DeliveryFeeOfferActions.deleteDeliveryFeeOffer,
  saveDeliveryFeeOffer: DeliveryFeeOfferActions.saveDeliveryFeeOffer,
}

export default connect(
  mapState,
  mapDispatch
)(DeliveryFeeOffer)



// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/index.js